import { TFunction } from 'react-i18next';
import { Path, UseFormGetValues } from 'react-hook-form';
import { returnFileSize } from '../returnFileSize';
import { FileFieldFieldValidationOptions } from '../index';

export function applyFileFieldValidationOptions<TFieldValues>(
  name: Path<TFieldValues>,
  getValues: UseFormGetValues<TFieldValues>,
  t: TFunction,
  rules: FileFieldFieldValidationOptions<TFieldValues> = {},
) {
  if (rules.atLeastOneFile) {
    rules.validate = {
      hasAtLeastOneFileSelected() {
        const files = (getValues(name) as File[]) || [];

        return (
          files.length > 0 || t('site.pricing.validation.error.code.REQUIRED')
        );
      },

      ...rules.validate,
    };
  }

  if (rules.maxFileSize?.value) {
    const maxFileSize = rules.maxFileSize.value * 1024;
    const defaultErrorMessage = t(
      'site.pricing.validation.error.code.MAX_FILE_SIZE',
      {
        0: returnFileSize(maxFileSize, 0),
      },
    );

    rules.validate = {
      isValidFileSize() {
        const files = (getValues(name) as File[]) || [];
        const filesExceedingMaxSize = files.filter(
          (file) => file.size > maxFileSize,
        );
        const isValid = filesExceedingMaxSize.length === 0;

        return isValid || rules.maxFileSize?.message || defaultErrorMessage;
      },

      ...rules.validate,
    };
  }

  return rules;
}
